<!-- Trigger button -->
<button
  #popoverTriggerRef="ngpPopoverTrigger"
  [ngpPopoverTrigger]="helpPopover"
  [ngpPopoverTriggerContainer]="'body'"
  [ngpPopoverTriggerPlacement]="placement"
  [attr.aria-label]="'Help: ' + (helpKey || 'information')"
  (ngpPopoverTriggerOpenChange)="onPopoverOpenChange($event)"
  ngpPopoverTriggerCloseOnOutsideClick
  class="help-trigger"
  type="button"
>
  <fa-icon [icon]="faInfoCircle"></fa-icon>
</button>

<ng-template #helpPopover>
  <div ngpPopover data-help-popover class="help-panel">
    <div class="help-panel-header">
      <h6 [id]="titleId" class="help-panel-title">{{ displayTitle }}</h6>
    </div>

    <div class="help-popover-content" [ngStyle]="customStyles">
      @if (contentState$ | async; as state) {
        @if (state.status === "loading") {
          <div class="loading"></div>
        }

        @if (state.status === "error") {
          <div class="error">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            <div class="message">
              {{ state.error }}
            </div>
          </div>
        }

        @if (state.status === "success") {
          <div class="content" [innerHTML]="state.content"></div>
        }
      }
    </div>
  </div>
</ng-template>
